import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading, BHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const RiskPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Business Risks"
        subTitleText="事業等のリスク"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <Paragraph>
          当社グループの事業は、「流通小売事業」、「リテールAI事業」及び「その他事業」の3つの事業セグメントで構成されております。「中核事業である流通小売事業セグメント及び当社グループ共通のリスク」のほか、事業領域ごとに想定されるリスクをセグメント別に記載しております。
        </Paragraph>
        <Paragraph>
          また、当社グループは、当社グループでコントロールできない外部要因や、事業上のリスクとして具体化する可能性が必ずしも高くないとみられる事項を含め、投資家の投資判断上重要と考えられる事項については積極的に開示することとしておりますが、これらは当社グループの全てのリスクを網羅したものではなく、記載された事項以外の予見できないリスクも存在します。このようなリスクが現実化した場合には、当社グループの事業、経営成績、財政状態及びキャッシュ・フローの状況に重要な影響を与える可能性があります。
        </Paragraph>
        <Paragraph>
          当社グループはこれらのリスク発生の可能性を認識した上で、その発生の予防及び発生時の対応に努める方針でありますが、当社グループの経営状況及び将来の事業についての判断は、以下の記載事項を慎重に検討した上で行われる必要があると考えております。
        </Paragraph>
        <Paragraph>
          なお、文中の将来に関する事項は、2026年6月30日現在において当社グループが判断したものであります。
        </Paragraph>
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>
          中核事業である流通小売事業セグメント及び当社グループ共通のリスク
        </AHeading>
        <BHeading>
          （1）店舗拡大及び店舗改装を含む事業規模の拡大と人材確保及び労働環境の変化
        </BHeading>
        <Paragraph>
          当社グループは、成長戦略として、重点地域におけるドミナント戦略及び未出店地域への出店強化や既存店舗の改装を通じた事業規模の拡大を進めてまいりますが、同業他社及び他業種との競合が激化した場合や戦略に合致する店舗用地の確保が困難となった場合、その他不動産価格や建築コスト、資金調達コスト等の上昇、国内景気及び個人消費の減退等、当社グループを取り巻く経済条件に変化が生じた場合、出店及び改装のペースが減速し、新規出店店舗及び改装店舗に係る売上又は利益が想定を下回る可能性があります。
        </Paragraph>
        <Paragraph>
          また、当社グループでは、パート社員であるアソシエイト職を含めた積極的な人材採用を進め、並行して新入社員からマネジメント職まで様々な研修プログラムを実施しております。しかしながら、労働人口減少に伴う人材確保競争の激化により店舗数の拡大ペースに対応した人材の確保・育成が予定どおりに進まない場合や労働需給の逼迫等によって時間給単価が上昇した場合、想定を上回る費用が発生したり、店舗の出店や改装のペースが鈍化する可能性があります。
        </Paragraph>
        <Paragraph>
          これらの要因によって、当社グループの成長戦略が想定どおりに実行できなかった場合、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（2）感染症の流行による影響</BHeading>
        <Paragraph>
          社会の経済活動に重大な影響を及ぼす規模で感染症の流行が発生又は拡大し、当社グループの店舗やプロセスセンター、取引先、仕入先、宿泊施設等において感染症の蔓延が生じた場合や感染拡大防止のために経済活動の制限が行われた場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>
          （3）消費者需要、天候及び季節性等事業を取り巻く外部環境
        </BHeading>
        <Paragraph>
          景気動向・消費動向等の経済情勢、消費者需要の変化、天候の変化及び季節性による需要の偏りといった不可避的な要因が当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Paragraph>
          天候及び季節性のリスクとして、当社グループの店舗・施設の周辺地域において大地震や台風、津波等の自然災害、火災或いは予期せぬ事故等が発生した場合、店舗・施設への物理的な損害、その他当社グループの供給業者又は仕入・流通ネットワークに影響を及ぼす可能性があります。このような事象に備え、当社グループにおいては、不測の事態が生じた際の社内における迅速な情報共有と管理体制を構築し、適時適切に事態を収束させることができる体制を整えておりますが、想定を上回る事象の発生により当社グループの販売活動や流通・仕入活動が阻害された場合や、人的又は物的な被害があった場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Paragraph>
          また、流通小売業界は、国内外の景気動向、消費動向、物価動向、燃料・エネルギー価格の動向、為替動向等の経済情勢、消費者需要の変化により大きな影響を受けます。こういった変化に対し、当社は適時適切な価格戦略、在庫管理、販売力強化によりその影響を限定するよう努めておりますが、こうした外部要因の急激な変動等が生じ、これに対する十分な対応ができなかった場合、既存店の売上や収益性、新規出店・改装計画等に支障をきたし、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（4）仕入価格及び原油・原材料価格等の上昇</BHeading>
        <Paragraph>
          当社グループの流通小売事業ではプライベート・ブランド（PB）商品及び惣菜製造等で一部原材料の仕入をしております。それら仕入価格は、気温上昇や天候による需給の変化等により影響を受ける可能性があるほか、一部の原材料は海外子会社を通じて外貨で仕入れるため、為替変動による影響を受ける可能性があります。当社グループでは、特定の取引先や地域に依存することのないよう仕入の分散化を図っておりますが、想定外の異常気象等により原材料の仕入価格が高騰した場合、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Paragraph>
          また、原油・原材料価格等の高騰により、流通小売事業において、包装資材として使用しているレジ袋やトレー、フィルム等石油製品の仕入価格も上昇します。加えてエネルギー価格の上昇から各店舗で発生する水道光熱費の上昇や物流面におけるガソリン等の価格上昇の影響を受けることから、原油価格等の高騰は店舗運営コスト及び物流コスト増の要因となります。さらに、宅配の増加に伴い、トラックドライバーの需要が近年増加している一方で、その担い手の減少が見込まれることやトラックドライバーの労働環境改善などの社会的要請により、トラックドライバーの人件費の上昇を受けて、物流コストが増加する可能性があります。これらの外部環境による価格変動を顧客への販売価格に適切な程度及び時期において転嫁できない場合や、顧客への価格転嫁により当社グループの競争力が低下する場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（5）法律等による規制</BHeading>
        <Paragraph>
          店舗の出店においては大規模小売店舗立地法、商品の販売においては景品表示法、食品表示法及び食品衛生法、商品の仕入れにおいては下請法や環境に関するリサイクル関連法等の様々な法的規制を受けております。また、当社グループは中国や韓国において関係会社を保有しておりますが、海外においては現地法令の適用を受けるほか、政治・経済・文化・宗教・習慣や為替等の様々な影響を考慮する必要があります。当社グループでは法規制の遵守に努め、許認可の取得又は更新を遅滞なく実施できる体制整備に努めておりますが、法令の改正や解釈の厳格化により主要な事業の遂行が制限される可能性があるほか、法規制の遵守に想定外のコストが必要となる可能性があります。また、当社グループが法令等に違反した場合、課徴金等のペナルティに加えて、当社グループの社会的信用が失墜するなど、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（6）個人情報保護法</BHeading>
        <Paragraph>
          当社グループは、流通小売事業をはじめ当社グループにおいて営む各事業のお客様の個人情報を数多く保有・管理しております。これらの情報の管理については、「個人情報保護規程」を定め漏洩が生じないよう最大限の対策を講じ細心の注意を払っておりますが、不測の事態により、万一、外部漏洩等が発生した場合は、当該個人への賠償や当社グループの社会的信用の失墜等により、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（7）情報セキュリティ・システムトラブル</BHeading>
        <Paragraph>
          当社グループは、情報やコンピューター及びネットワーク等の情報システム（以下「情報資産」といいます。）を「ヒト・モノ・カネ」に続く第4の資産として位置付けております。情報資産を重要な資産とし保護するため、「情報セキュリティポリシー」を定め情報セキュリティ委員会において継続的にリスク分析・評価を行い管理しております。
        </Paragraph>
        <Paragraph>
          しかしながら、想定外の自然災害や事故等により設備が甚大な損害を被った場合や、当社グループや当社グループの取引先へのコンピュータウィルスの不正侵入、サイバーアタック、従業員の過誤によるシステム障害等が発生した場合、社会的信用が毀損する等して、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Paragraph>
          また、当社グループでは、業務効率化や新たな顧客価値の創出を目的として、生成AIをはじめとするAI技術の活用を拡大しております。AIの活用にあたっては、学習データやプロンプトへの入力を通じた個人情報・機密情報等の漏えい、AIが生成する情報の不正確性やバイアスに起因する誤った意思決定・顧客対応、第三者の知的財産権侵害等のリスクが想定されます。当社グループでは、AI利用に関する社内ガイドラインの策定及びデータの取得・管理・利活用に関するデータガバナンス体制の整備を進めておりますが、AI関連技術の急速な進展や国内外における関連法規制・ガイドラインの変化に対して十分な対応が図れない場合や、想定外のインシデントが発生した場合には、社会的信用の毀損、損害賠償責任の発生等により、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（8）訴訟及びレピュテーションリスク</BHeading>
        <Paragraph>
          当社グループは、法令を遵守した事業活動を行っており、グループリスクコンプライアンス委員会を組織するなど社内においても法令遵守の意識向上を図っておりますが、通常の業務遂行において、従業員による法令違反や不適正行為、契約を巡る紛争や労働紛争、損害賠償等、第三者からの訴訟その他法的手段の提起等、様々な法的手続きに服するリスクを有しております。長期的かつ多額な費用を要する訴訟や社会的影響の大きい訴訟等が発生した場合、金銭的な負担に加え、企業イメージの悪化等、社会的なレピュテーションの低下により当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（9）固定資産の減損</BHeading>
        <Paragraph>
          当社グループは、事業の用に供する設備や不動産をはじめとする様々な固定資産を所有しております。保有資産の将来キャッシュ・フローの減少などにより、減損損失の認識及び測定を実施した結果、固定資産の減損損失の計上が必要となった場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（10）食品・商品の安全性・衛生管理</BHeading>
        <Paragraph>
          当社グループは、生鮮食品や惣菜をはじめとした食品を強みとして、お客様の多様なニーズにお応えするため生鮮食品から加工食品、日配食品まで幅広い商品を取り扱っており、「商品品質衛生管理規程」を定め当社流通小売事業における品質管理部門を中心に管理体制を構築しております。各店舗やセントラルキッチンにおいては規程の遵守状況について、食品衛生法及び食品表示法、HACCP、品質マネジメント認証に基づいた衛生管理がなされているかの定期的な点検を実施し、品質管理部においてはその実施状況の確認及び指導を行っております。また、内部監査室の店舗監査においては、そのサイクルと有効性を評価しております。さらに、外部機関による食品衛生法の遵守状況についての定期検査を受けるなど、安全性及び衛生管理の徹底を図っているほか、店舗や製造部門の従業員には衛生管理及びコンプライアンスに関する研修制度を設け社内独自の資格試験の受験を義務化する等安心・安全・適正にお客様へ提供するために様々な取組みを進めております。しかしながら、万一、食中毒や異物混入、原産地やアレルギー表記等の誤りなど、不適切な食品・商品の提供や表示がなされた場合や、食品・商品に関してSNS等における不適切な情報拡散がなされた場合には、当局による処分や措置の対象となり、また、販売自粛や商品回収、表示の是正等の措置や再発防止策の実施等に関して、多額のコストが発生する可能性があるほか、当社グループの商品に対する信頼の低下等につながるおそれがあります。当社グループでは、記載のとおり各部門の相互確認による管理体制及び社員教育体制によって最大限の品質管理を行っておりますが、これらの事象が発生した場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（11）競合による影響</BHeading>
        <Paragraph>
          当社グループは流通小売業を基幹事業として営んでいますが、日本国内においては少子高齢化等によるマーケットの縮小が見込まれる一方で、同業他社のほか、競合業態であるスーパーマーケット、GMS、ドラッグストア等との間で激しい競争に晒されております。このような競争環境の下、当社グループでは、IT・AIにより顧客の購買動向の把握や分析等を推し進めるとともに、ローコストオペレーション・商品力強化により高い価格競争力を有することで、競合他社との差別化を図っております。しかしながら、競合他社によるディスカウント業態の多店舗展開や業種・業態をこえた競争が激化する場合、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（12）M&amp;Aによる事業拡大について</BHeading>
        <Paragraph>
          当社グループは、事業規模の拡大及び事業領域の多角化を実現する手段の一つとして、M&amp;Aを実施する可能性があります。しかしながら、その実施には多額の資金を必要とする場合があり、一時的に財務状況及び業績に影響を及ぼす可能性があるほか、実施後の事業の展開が計画どおりに進まない場合や、想定以上の支出を要する場合等には、それらの投融資活動により想定した効果を得られない可能性があります。
        </Paragraph>
        <Paragraph>
          対象企業の選定にあたっては、国内外を問わず、対象企業の財務内容、契約関係、事業内容等について詳細なデューディリジェンス（投資案件評価）を実施し、リスクの低減に努めておりますが、M&amp;Aの実施後に偶発債務の発生や未認識債務が判明した場合、その他買収前に想定し得なかった事象が判明した場合には、当社グループの事業、財政状態及び経営成績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（13）有利子負債について</BHeading>
        <Paragraph>
          当社グループは、M&amp;A資金として金融機関より多額の借入を実施いたしました。今後、市場金利が大幅に上昇した場合、借入金に係る金利のうち、変動金利部分については、利息負担の増加により業績に影響を与える可能性があります。また、金融機関との間で締結している借入金の一部には財務制限条項が定められており、万一、当社グループの業績が悪化し、当該財務制限条項に抵触した場合には、期限の利益を喪失し、当社グループの事業、財政状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（14）のれんの減損</BHeading>
        <Paragraph>
          当社グループは、2025年7月の株式会社西友の全株式取得に伴い、多額ののれんを計上しており、総資産に占める当該のれんの割合が高くなっております。当該のれんについては、将来の収益力を適切に反映していると判断しておりますが、収益力が低下した場合には減損損失を計上することとなります。今後、シナジーの最大化に向けて各種施策を実施し、収益力の向上に努めてまいります。しかしながら、これらの施策や統合プロセスが想定どおりに進まず、当該のれんに係る減損損失を計上する場合は、当社グループの事業、財政状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（15）当社株式の流動性について</BHeading>
        <Paragraph>
          当社は、当社株式の流動性の確保に努めることとしておりますが、株式会社東京証券取引所の定める流通株式比率は2026年6月期末時点において26.4％であります。今後は、当社の事業計画に沿った成長資金の公募増資による調達、大株主及び役員への一部売出しの要請、ストック・オプションの行使による流通株式数の増加分を勘案し、これらの組み合わせにより、流動性の向上を図っていく方針ではありますが、何らかの事情により上場時よりも流動性が低下する場合には、当社株式の市場における売買が停滞する可能性があり、それにより当社株式の需給関係にも悪影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（16）大株主との関係</BHeading>
        <Paragraph>
          2026年6月30日現在、当社株式の大部分は、創業者かつ当社会長である永田久男並びに永田久男及びその親族の資産管理会社である株式会社ティー・エイチ・シー及び株式会社Heroic investmentにより保有されております。
        </Paragraph>
        <Paragraph>
          かかる大株主が当社の事業その他に関して有する利益は他の株主の利益と異なる可能性があり、その保有方針や議決権の行使方針によっては、当社の株主総会決議の結果に重要な影響を及ぼすなど、当社グループの事業、財政状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>リテールAI事業に関するリスク</AHeading>
        <BHeading>（1）先行投資の発生及び損失の継続計上</BHeading>
        <Paragraph>
        当社グループは、リテールAI事業への先行投資を行っており、リテールAI事業では2024年6月期まで連続したセグメント損失を計上しておりました。 これは、新規のプロダクト開発や既存プロダクトの改良のための開発投資や人件費、有形固定資産の取得等によるものです。一方で、流通小売事業においては、安定的に営業活動におけるキャッシュ・フローのプラスを計上しております。経営戦略上も、流通小売事業の売上高や収益性が継続的に成長・改善していく中で、リテールAI事業への積極的な投資を行っていくことを前提としております。
        </Paragraph>
        <Paragraph>
          しかしながら、リテールAI事業においては、様々な実証実験の実施や新規事業の開発を行っておりますが、計画どおりにプロダクト化や開発が進捗する保証はなく、また、既存又は開発予定のプロダクトの普及・展開においても計画どおりに進捗する保証はありません。また、これらのプロダクト開発に必要なエンジニア等を確保できる保証もありません。さらに、リテールテック市場は技術革新が著しいことから、今後リテールAI事業の成長のための先行投資が想定以上に発生する可能性もあります。これらの要因その他本「事業等のリスク」に記載のリスクの顕在化等により、想定していた事業計画を達成できなかった場合、リテールAI事業において安定した収益を得ることができず、投資した資金が回収できない等、当社グループの事業、財務状況及び業績に影響を与える可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（2）法律による規制</BHeading>
        <Paragraph>
          当社グループは、リテールAI事業において、精密機械の製造やDXソリューションサービスを提供する事業を行っているため、電波法や個人情報保護法など、企業活動に関わる各種法令の規制を受けております。当社グループは、コンプライアンス体制の充実が重要であると考えており、法務担当部署が中心となり、法令遵守状況の確認や法令改正時の事業への影響度の見積りなどを行っております。
        </Paragraph>
        <Paragraph>
          しかしながら、将来において、当社グループが提供するプロダクト及びソリューションが法的規制に抵触する可能性を完全に否定することはできず、また、今後の法改正や法的解釈の変更等により、当社グループのプロダクト及びソリューションの提供が困難になるような場合には、当社グループの事業、財務状況及び業績に影響を与える可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（3）ハードウエアやソフトウエアの不具合</BHeading>
        <Paragraph>
          当社グループは、リテールAI事業において、IoTデバイスを小売店舗に導入することによるソリューションの提供やデータの取得を行っております。ハードウエア、ソフトウエアともに品質管理体制を確立し、プロダクトやソリューションの提供を実施する中で、改善・改良を図るなど、製品の安全性確保やサービスの不具合の未然防止に努めております。
        </Paragraph>
        <Paragraph>
          しかしながら、これらの不具合を将来に渡って完全に防止することは不可能であり、万一、大規模な製品の欠陥が生じたり、それに起因する損害が発生したりした場合、当社グループの事業、財務状況及び業績に影響を与える可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（4）競合について</BHeading>
        <Paragraph>
          当社グループは、リテールAI事業において、「オペレーション・ドリブン」を軸に置いて営業活動を行っており、導入・運用実績の観点でも世界トップレベルであると認識しております。一方で、リテールテック市場では国内外に多数の競合他社が存在します。今後リテールテック市場の成長に伴い、既存事業者との競争激化や、別業界から当該市場への事業者の新規参入等によって、競合他社に比して当社のプロダクトやソリューションの技術レベルや価格が劣後するような場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（5）世界情勢、サプライチェーンに関するリスク</BHeading>
        <Paragraph>
          当社グループは、リテールAI事業において、Skip
          CartをはじめとしたIoTデバイスの仕入を中国から行っております。国内外における重大な感染症によるサプライチェーンへの影響や米中の貿易摩擦、日中の政治・外交問題等が発生した場合、又はそれらの仕入先との関係が悪化した場合等には、IoTデバイスの調達が滞ることや取引機会が縮小する可能性があります。また、世界的な半導体需要の逼迫等により、協力工場からの安定した製品や部品の調達が困難となる可能性もあります。
        </Paragraph>
        <Paragraph>
          当社グループは、将来的な導入計画を見据え、協力工場との長期的関係の構築に努めるとともに、調達ルートの複数化などのリスクヘッジを検討しておりますが、これらのリスクが顕在化した場合、当社グループの事業、財務状況及び業績に影響を与える可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（6）知的財産権の管理について</BHeading>
        <Paragraph>
          当社グループは、関連法規に則り当社グループの活動が他社の著作権、特許権等の知的財産権を侵害すること、また、社内において業務で使用するソフトウエア等が他社の権利を侵害することがないよう、社内にて調査確認を行うことでその防止に努めており、判断が困難な場合には弁理士及び顧問弁護士の意見を聴取する体制をとっております。また、当社グループの事業運営上重要な技術等に関しては、特許申請を行うなど、自社の保有する知的財産権の保護に努めております。
        </Paragraph>
        <Paragraph>
          しかしながら、当社グループの事業領域に関する第三者の知的財産権の完全な把握は困難であるため、意図せず他社の知的財産権を侵害してしまう可能性があります。この場合、特許権侵害や商標権侵害を理由とする損害賠償請求や差止請求を受けたり、知的財産権の使用に対する対価の支払い等が発生したりする可能性があり、これらの場合には当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。また、当社が保有している知的財産権が第三者により侵害された場合にも、リテールテックを活用した当社グループのビジネスモデルの優位性が失われてしまう可能性があるほか、法的措置を含めた対応を要し、人的又は物的コストが発生するなど、当社グループの事業、財務状況及び業績に影響が及ぶ可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>その他事業に関するリスク</AHeading>
        <Paragraph>
          その他事業は主に旅館業及びゴルフ場運営事業などのリゾート事業を行っており、上記グループとしてのリスク事項以外に以下のリスクを認識しております。しかしながら、グループ全体における影響度としましては、低いものであると認識しております。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>（1）景気動向の変化について</BHeading>
        <Paragraph>
          リゾート事業においては、景気動向、特に個人消費の動向に大きな影響を受けます。経済情勢や為替情勢、天候及び季節性事情により旅行者が減少するなど景気の先行き不透明感につながる事象が払拭されない状況が中長期的に継続する場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>
          （2）労働力人口の減少に伴うサービスの質の低下への影響について
        </BHeading>
        <Paragraph>
          旅館業は労働集約的なサービスの提供を中心業務としておりますが、昨今の少子高齢化に伴う労働人口の減少により今後も中長期的な人手不足が継続したような場合には、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。また、顧客満足度向上及びリピート率向上のための従業員教育の実施や付加価値の提供による他社との差別化を図っておりますが、提供するサービスの質が低下した場合には顧客離れが起こり、当社グループの事業、財務状況及び業績に影響を及ぼす可能性があります。
        </Paragraph>
      </section>
    </Layout>
  )
}

RiskPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '経営方針', path: '/ir/manage' },
    { name: '事業等のリスク', path: '' },
  ]

  return (
    <>
      <Head
        title="事業等のリスク"
        description="トライアルホールディングスの事業領域ごとに想定されるリスクについて掲載しています。"
        ogp={{ url: 'ir/manage/risk/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
